import React from "react";
import { Phone, MessageCircle, Wrench, Flame, SlidersHorizontal as Sliders, ThermometerSnowflake, ShieldCheck, Clock } from 'lucide-react';
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Link } from "@/components/common/Link";
import { PHONE_LOCAL, PHONE_TEL_HREF, WHATSAPP_HREF } from "@/lib/contact";
export default function OvenRepairHero() {
  const services = [{
    icon: Flame,
    title: "إصلاح الإشعال والشعلات",
    description: "معالجة انسداد عيون الغاز وضعف اللهب وتصليح الإشعال الذاتي بدقة وأمان تام."
  }, {
    icon: Sliders,
    title: "صيانة مفاتيح التحكم والثيرموستات",
    description: "استبدال وصيانة مفاتيح درجات الحرارة وصمامات الأمان لمنع تسريب الغاز وضمان الاستقرار."
  }, {
    icon: ThermometerSnowflake,
    title: "ضبط توازن الحرارة والتوزيع",
    description: "حل مشاكل عدم نضج الطعام واختلال توزيع الحرارة داخل الفرن الكهربائي والغازي."
  }, {
    icon: Wrench,
    title: "توفير وتركيب قطع الغيار الأصلية",
    description: "تأمين قطع غيار أصلية لمختلف الماركات مع ضمان التركيب السليم والاختبار الفوري."
  }, {
    icon: ShieldCheck,
    title: "فحص تسريبات الغاز والكهرباء",
    description: "فحص شامل لجميع الوصلات الداخلية والمحابس لضمان أمان عائلتك ومنزلك بالكامل."
  }, {
    icon: Clock,
    title: "خدمة منزلية سريعة بالرياض",
    description: "فريق فني متخصص يصلك لباب المنزل في كافة أحياء الرياض ومجهز بأحدث معدات الكشف."
  }];
  return <section id="ovenrepairhero" dir="rtl" data-nav="light" className="bg-background text-foreground py-12 md:py-20 border-b border-border">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-6xl">
        {/* Hero Banner Header */}
        <div className="text-center max-w-3xl mx-auto space-y-4 mb-14">
          <Badge variant="secondary" className="px-3 py-1 text-sm font-medium">
            خدمات منزلية فورية في الرياض
          </Badge>
          
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold tracking-tight text-foreground leading-tight">
            صيانة أفران بالرياض بأعلى معايير الدقة والاحترافية
          </h1>

          <p className="text-muted-foreground text-base sm:text-lg leading-relaxed">
            تقدم شركة لمسة احتراف أفضل خدمات صيانة أفران بالرياض، حيث نتميز بفحص وتشخيص الأعطال، وإصلاح أنظمة الإشعال، وضبط مفاتيح التحكم، وتوفير قطع الغيار الأصلية في منزلك بسرعة وضمان معتمد.
          </p>

          {/* Primary Action Buttons */}
          <div className="flex flex-wrap items-center justify-center gap-3 pt-2">
            <Button asChild size="lg" className="gap-2 text-base font-semibold">
              <a href={PHONE_TEL_HREF}>
                <Phone className="size-5" />
                <span>اتصل الآن: {PHONE_LOCAL}</span>
              </a>
            </Button>
            <Button asChild variant="outline" size="lg" className="gap-2 text-base font-semibold">
              <Link to={WHATSAPP_HREF} newTab>
                <MessageCircle className="size-5 text-chart-4" />
                <span>محادثة واتساب سريعة</span>
              </Link>
            </Button>
          </div>
        </div>

        {/* Benefit & Service Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16">
          {services.map((item, index) => {
          const IconComponent = item.icon;
          return <div key={index} data-index={index} className="bg-card text-card-foreground border border-border rounded-lg p-6 shadow-xs hover:shadow-md transition-shadow flex flex-col justify-between">
                <div>
                  <div className="size-12 rounded-md bg-accent text-primary flex items-center justify-center mb-4">
                    <IconComponent className="size-6" />
                  </div>
                  <h2 className="text-xl font-bold mb-2 text-foreground">
                    {item.title}
                  </h2>
                  <p className="text-muted-foreground text-sm leading-relaxed">
                    {item.description}
                  </p>
                </div>
              </div>;
        })}
        </div>

        {/* Closing Call-To-Action Band */}
        <div className="bg-secondary text-secondary-foreground rounded-xl p-8 md:p-12 text-center shadow-lg">
          <div className="max-w-2xl mx-auto space-y-4">
            <h2 className="text-2xl sm:text-3xl font-bold">
              هل تواجه عطلاً في فرن الغاز أو الكهرباء؟
            </h2>
            <p className="text-secondary-foreground/80 text-sm sm:text-base leading-relaxed">
              فريقنا المتخصص في صيانة أفران بالرياض جاهز لخدمتك على مدار الساعة، نقوم بزيارتك المنزلية لتشخيص الخلل وإصلاحه في نفس اليوم بأفضل الأسعار.
            </p>
            <div className="flex flex-wrap items-center justify-center gap-4 pt-4">
              <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 font-bold px-6">
                <a href={PHONE_TEL_HREF}>
                  <Phone className="size-5 shrink-0" />
                  <span>طلب فني صيانة الآن</span>
                </a>
              </Button>
              <Button asChild variant="outline" size="lg" className="bg-transparent border-white/20 text-white hover:bg-white/10 font-bold px-6">
                <Link to={WHATSAPP_HREF} newTab>
                  <MessageCircle className="size-5 shrink-0 text-chart-4" />
                  <span>تواصل عبر الواتساب</span>
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}